import type { CustomerOrderDetail } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

interface InvalidateMyOrders {
  readonly detail: (orderId: string) => Promise<void>;
  readonly list: () => Promise<void>;
  readonly placement: (quoteRequestId: string) => Promise<void>;
  /** 그 견적의 주문하기 화면 데이터를 다시 요청하지 않고 낡은 것으로만 표시한다 — 다음에 열 때 새로 읽는다. */
  readonly expirePlacement: (quoteRequestId: string) => Promise<void>;
  /** 쓰기 응답으로 받은 최신 상세를 캐시에 넣는다 — 같은 상세를 다시 요청하지 않는다. */
  readonly putDetail: (order: CustomerOrderDetail) => void;
}

/**
 * 내 주문 캐시 갱신 — 목록·주문하기 화면 invalidation 과 상세 캐시 쓰기를 한곳에 모은다.
 * 무효화는 재조회 promise 를 돌려준다 — 뮤테이션이 기다리면 새 상태가 오기 전에 버튼이 풀리지 않는다.
 */
export const useInvalidateMyOrders = (): InvalidateMyOrders => {
  const utils = trpc.useUtils();

  return {
    detail: (orderId) => utils.orders.getMine.invalidate({ orderId }),
    list: () => utils.orders.listMine.invalidate(),
    placement: (quoteRequestId) => utils.orders.getPlacement.invalidate({ quoteRequestId }),
    expirePlacement: (quoteRequestId) =>
      utils.orders.getPlacement.invalidate({ quoteRequestId }, { refetchType: 'none' }),
    putDetail: (order) => {
      utils.orders.getMine.setData({ orderId: order.id }, order);
    },
  };
};
